var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.themeCls, ( _obj = {}, _obj[("" + _vm.themeDisCls)] = !this.canClick, _obj )],on:{"click":_vm.countDown}},[_vm._v("\n  "+_vm._s(_vm.content)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }